import { httpLanguageNegotiator } from 'http-header-value/headers.js';
import { HttpError } from '../http-error.js';
import { addResponseHeader } from '../util/add-response-header.js';
/**
 * Dispatches request processing by requested language.
 *
 * Performs [content negotiation] based on [Accept-Language] header. Then calls handler based on negotiation results.
 *
 * Appends `Vary: Accept-Language` header to the response.
 *
 * Issues 406 (Not Acceptable) error if no matching handler found.
 *
 * [content negotiation]: https://developer.mozilla.org/en-US/docs/Web/HTTP/Content_negotiation
 * [Accept-Language]: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Accept-Language
 */
export function dispatchByLanguage(languages) {
    const negotiator = httpLanguageNegotiator(languages);
    return ({ request, response, next }) => {
        const { 'accept-language': acceptLanguage = '*' } = request.headers;
        const handler = negotiator(acceptLanguage);
        if (!handler) {
            return Promise.reject(new HttpError(406));
        }
        addResponseHeader(response, 'Vary', 'Accept-Language');
        return next(handler.bind(languages));
    };
}
//# sourceMappingURL=dispatch-by-language.handler.js.map